var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has__nav__menu"},[_c('SearchListBox',{key:_vm.setFullPath,attrs:{"query":_vm.setApiQuery,"basePath":_vm.setBaseURI}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }